module.exports = __webpack_public_path__ + "static/media/rm_06-29.e0fb6d8e.png";